const productsData = [
  {
    id: 1,
    name: "Modern Sofa",
    price: 1500,
    rating: 4.5,
    category: "Furniture",
    image: "https://p.rmjo.in/productSquare/p7zyrfjx-500x500.webp",
  },
  {
    id: 2,
    name: "Double Bed",
    price: 1200,
    rating: 5,
    category: "Furniture",
    image: "https://images.unsplash.com/photo-1615874959474-d609969a20ed",
  },
  {
    id: 3,
    name: "Refrigerator",
    price: 1800,
    rating: 4,
    category: "Appliances",
    image: "https://p.rmjo.in/productSquare/9l42gmid-500x500.webp",
  },
  {
    id: 4,
    name: "Washing Machine",
    price: 1400,
    rating: 3.5,
    category: "Appliances",
    image: "https://p.rmjo.in/productSquare/y8elks0x-500x500.webp",
  },
];

export default productsData;